import {useAction}                          from '../useBaseHooks';
import {getClassifyDescribeAllTagsEndpoint} from '../endpoints/classify/classifyEndpoints';

export const useClassifyDescribeAllTags = (classify, restSettings = null) =>
	useAction(getClassifyDescribeAllTagsEndpoint(classify), 'POST', restSettings);